<template>
	<div class="main">
		<vHeader/>
		<div class="wrap">
			<slot/>
		</div>

		<minicartRes/>
	</div>
</template>

<script>
import vHeader from "@/components/header/index.vue";
import minicartRes from "@/components/cart-mini/res.vue";

export default {
	components: {vHeader, minicartRes}
};
</script>

<style lang="scss" scoped>
.main {
	.wrap {
		padding-top: calc(#{$header} + #{em(65)});

		@include res(xsmall) {
			padding-top: calc(#{$header} + #{em(33)});
		}
	}
}
</style>
